import {computed, defineComponent, ref, watch} from 'vue';
import {OrganisationInvoiceSetting} from "@/api/klip-api.proxy";
import Or from "ol/format/filter/Or";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlInvoiceSettingCard',
    props: {
        invoiceSetting: {
            type: Object as () => OrganisationInvoiceSetting,
            default: () => ({}),
            required: true
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        showContactInfo: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: ['onUpdate'],
    setup(props, { emit }) {
        const organisationInvoiceSetting = ref<OrganisationInvoiceSetting>(props.invoiceSetting);

        const hasContactInfo = computed(() => {
            if(!props.showContactInfo) return false;
            return !!organisationInvoiceSetting.value.invoiceContactName || !!organisationInvoiceSetting.value.invoiceContactEmail || !!organisationInvoiceSetting.value.invoiceContactPhoneNumber;
        })

        const updateInvoiceSetting = () => {
            const invoiceSettingToUpdate = new OrganisationInvoiceSetting(organisationInvoiceSetting.value);
            emit('onUpdate', invoiceSettingToUpdate);
        }

        watch(() => props.invoiceSetting, (newInvoiceSetting) => { organisationInvoiceSetting.value = newInvoiceSetting }, { immediate: true, deep: true });

        return {
            organisationInvoiceSetting,
            updateInvoiceSetting,
            hasContactInfo
        }
    }
})
